import api from './api';

export const previewMigration = (csv) =>
  api.post('/admin/member-migration/preview', { csv }).then(r => r.data);
